var _classCallCheck = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var BlockStream = require('block-stream2');

var stream = require('readable-stream');

var ChunkStoreWriteStream = /*#__PURE__*/function (_stream$Writable) {
  "use strict";

  _inherits(ChunkStoreWriteStream, _stream$Writable);

  function ChunkStoreWriteStream(store, chunkLength) {
    var _this;

    var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, ChunkStoreWriteStream);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ChunkStoreWriteStream).call(this, opts));

    if (!store || !store.put || !store.get) {
      throw new Error('First argument must be an abstract-chunk-store compliant store');
    }

    chunkLength = Number(chunkLength);
    if (!chunkLength) throw new Error('Second argument must be a chunk length');
    _this._blockstream = new BlockStream(chunkLength, {
      zeroPadding: false
    });
    _this._outstandingPuts = 0;
    var index = 0;

    var onData = function onData(chunk) {
      if (_this.destroyed) return;
      _this._outstandingPuts += 1;
      store.put(index, chunk, function () {
        _this._outstandingPuts -= 1;

        if (_this._outstandingPuts === 0 && typeof _this._finalCb === 'function') {
          _this._finalCb(null);

          _this._finalCb = null;
        }
      });
      index += 1;
    };

    _this._blockstream.on('data', onData).on('error', function (err) {
      _this.destroy(err);
    });

    return _this;
  }

  _createClass(ChunkStoreWriteStream, [{
    key: "_write",
    value: function _write(chunk, encoding, callback) {
      this._blockstream.write(chunk, encoding, callback);
    }
  }, {
    key: "_final",
    value: function _final(cb) {
      var _this2 = this;

      this._blockstream.end();

      this._blockstream.once('end', function () {
        if (_this2._outstandingPuts === 0) cb(null);else _this2._finalCb = cb;
      });
    }
  }, {
    key: "destroy",
    value: function destroy(err) {
      if (this.destroyed) return;
      this.destroyed = true;
      if (err) this.emit('error', err);
      this.emit('close');
    }
  }]);

  return ChunkStoreWriteStream;
}(stream.Writable);

module.exports = ChunkStoreWriteStream;